module.exports = __webpack_public_path__ + "static/media/thesis_PDF3.e5a0ee50.jpg";